import * as React from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { themePattern } from '../constants/pattern';
import { PropsStackInstructions } from './../types';
import * as WebBrowser from 'expo-web-browser';
import BtnRectangle from '../components/buttons/BtnRectangle';


const youtubeInstrucao: any = "https://www.youtube.com/watch?v=J9UIUGKqdvU";

const { width, height } = Dimensions.get('window')


export default function Instructions({ navigation }: PropsStackInstructions) {
  const video = React.useRef(null);
  const [status, setStatus] = React.useState({});
  let openHelp = () => {
    WebBrowser.openBrowserAsync(youtubeInstrucao)
  };
  return (
    <View style={styles.Main}>
      <View style={styles.youtube}>
        <Text style={styles.text}>A versão “on line” interativa do Disco de Aminoácidos, foi desenvolvida a partir da versão impressa. Há uma breve descrição das características de cada aminoácido e a visualização das moléculas em 3-D, sendo possível girá-las 360 graus. O verso do disco contém a tabela do código genético.</Text>

      </View>

      {/* <View style={styles.containerYoutube}>
              <Video
                ref={video}
                style={styles.video}
                source={{
                  uri: 'https://illiamw.github.io/app/discoAminoacidos/instrucoes.mp4',
                }}
                useNativeControls
                resizeMode="contain"
                isLooping
                onPlaybackStatusUpdate={status => setStatus(() => status)}
              />
            </View> */}

      <View>
        <BtnRectangle
          icon={"youtube-play"}
          key={"apresentacao"}
          name={"APRESENTAÇÃO"}
          onPress={() => openHelp()}
        />
      </View>

    </View>
  );
}

function Styles() {

  //Mobile
  if (themePattern.breakpoint.mobile >= width)
    return StyleSheet.create({
      Main: {
        backgroundColor: themePattern.mobile.white,
        borderColor: themePattern.mobile.black,
        borderStyle: 'solid',
        borderWidth: 2,
        borderRadius: 15,
        margin: 15,
        padding: 15,
        alignContent: 'center',
        justifyContent: 'space-around',
        flex: 1,

      },
      text: {
        textAlign: "center",
        fontSize: themePattern.mobile.par1
      },
      youtube: {
        justifyContent: "center"
      },
      buttons: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }
    });

  //Tablet
  else
    return StyleSheet.create({
      Main: {
        backgroundColor: themePattern.tablet.white,
        borderColor: themePattern.tablet.black,
        borderStyle: 'solid',
        borderWidth: width <= 800 ? 2 : 0,
        borderRadius: 15,
        margin: width > 1200 ? themePattern.desktop.retreatDesketop : themePattern.desktop.retreat,
        width: width > 1200 ? 1200 : 'auto',
        marginTop: 15,
        marginBottom: 15,
        padding: width <= 1300 ? themePattern.tablet.retreat :  themePattern.desktop.retreatFull,
        alignContent: 'center',
        justifyContent: 'space-around',
        flex: 1,

      },
      text: {
        textAlign: "center",
        fontSize: width <= 1200 ? themePattern.tablet.par1 :  themePattern.desktop.par1
      },
      youtube: {
        justifyContent: "center"
      },
      buttons: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }
    });
}

const styles = Styles()

